import { render } from "./ConfirmedAttendanceList.vue?vue&type=template&id=9275caba&scoped=true"
import script from "./ConfirmedAttendanceList.vue?vue&type=script&lang=js"
export * from "./ConfirmedAttendanceList.vue?vue&type=script&lang=js"

import "./ConfirmedAttendanceList.vue?vue&type=style&index=0&id=9275caba&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9275caba"

export default script